import { useState, useEffect, useCallback } from "react";
import Select, { MultiValue, StylesConfig } from "react-select";
import { Option } from "../../interface/Option";
import { DrugMedicalGroupAxiosInstance } from "../../Network/DrugMedicalGroupAxiosInstance";

const ListOfDrugMedical = ({ onChange, clear, defaultValue }: any) => {
  const [options, setOptions] = useState<Option[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<Option[]>([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState<string>("");

  // loadOptions
  const loadOptions = useCallback(async () => {
    if (inputValue.trim().length < 3) {
      setOptions([]);
      return;
    }

    setLoading(true);
    try {
      const response = await DrugMedicalGroupAxiosInstance.get(`/searchDrugsMedicalGroup`, {
        params: { search: inputValue },
      });

      const data = response.data?.result || [];
      const formattedOptions: Option[] = data.map((item: any) => ({
        value: item.id.toString(),
        label: `(${item.id}) ${item.name}`,
      }));

      setOptions(formattedOptions);
    } catch (error) {
      console.error("Error loading Drug medical groups:", error);
    } finally {
      setLoading(false);
    }
  }, [inputValue]);

  //   Call load when searching
  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      loadOptions();
    }, 100);
    return () => clearTimeout(debounceTimeout);
  }, [inputValue, loadOptions]);

  //   Update the selected values
  const handleChange = (selected: MultiValue<Option>) => {
    setSelectedOptions(selected as Option[]);
    onChange(selected as Option[]);
  };

  // Reset selected values ​​when clearing values
  useEffect(() => {
    if (clear) {
      setSelectedOptions([]);
    }
  }, [clear]);

  // Set default values ​​on load
  useEffect(() => {
    if (defaultValue) {
      setSelectedOptions(defaultValue);
    }
  }, [defaultValue]);



  // styles
  const customStyles: StylesConfig<Option, true> = {
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#007BFF",
      color: "#FFFFFF",
      borderRadius: "5px",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: "#FFFFFF",
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: "#FFFFFF",
      ":hover": {
        backgroundColor: "#0056b3",
        color: "#FFFFFF",
      },
    }),
    option: (styles, { isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "#007BFF" : "#FFFFFF",
      color: isSelected ? "#FFFFFF" : "#000000",
      ":hover": {
        backgroundColor: "#0056b3",
        color: "#FFFFFF",
      },
    }),
  };


  return (
    <Select
      isMulti
      value={selectedOptions}
      onChange={handleChange}
      options={options}
      isLoading={loading}
      onInputChange={setInputValue}
      placeholder="Type at least 3 letters to search..."
      styles={customStyles} // Apply colors
    />
  );
};

export default ListOfDrugMedical;